export default function assetsByTypeDirective() {
  return {
    template: require('./assets-by-type.html'),
    restrict: 'E',
    controller: 'AssetsByTypeController',
    controllerAs: 'assetsByTypeVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '=',
      assetType: '=',
      assetTypes: '=',
      assignAsset: '<',
      showItAsset: '<',
      showCriticality: '<',
      showDataUsage: '<',
      showInherentRisk: '<',
      showResidualRisk: '<',
      showAdd: '<',
      showEdit: '<',
      showInstanceCriticality: '<',
      showInstanceDataUsage: '<',
      showInstanceNotes: '<',
      showInstanceRiskCount: '<',
      showInstanceActionIcons: '<',
      showRiskControlCount: '<',
      tooltipAppendToSelector: '@',
      process: '<',
      isPraProcessMain: '<',
      isEditProcessDialog: '<',
      showBulkDelete: '<',
      showSyncAsset: '<',
      hasNetComply: '=',
      hasEndpointManagement: '=',
      rmmReportingSource: '=',
    },
  };
}
